<i18n>
{
  "en": {
    "appName": " Verification System",
    "help": "Help",
    "privacyPolicy": "Privacy Policy"
  },
  "ja": {
    "appName": "手続きシステム",
    "help": "ヘルプ",
    "privacyPolicy": "Privacy Policy"
  }
}
</i18n>
<template>
  <div>
    <Toolbar :title="campaign.name + $t('appName')"></Toolbar>
    <br />
    <br />
    <v-container fill-height style="flex-direction: column;">
      <router-view></router-view>
    </v-container>

      <v-flex height="auto" dark app style="padding: 16px; background: black;">
        <v-layout column wrap>
          <!--
          <v-flex text-xs-center xs6>
            <a
              style="text-decoration:none;"
              target="_blank"
              href="https://corporate.tokyocameraclub.com/privacy.php"
            >
              <v-btn depressed small>{{ $t('help') }}</v-btn>
            </a>
          </v-flex>
          -->
          <v-flex text-xs-center xs6>
            <a
              style="text-decoration:none;"
              target="_blank"
              href="https://corporate.tokyocameraclub.com/privacy.php"
            >
              <span style="color: white;">{{ $t('privacyPolicy') }}</span>
            </a>
          </v-flex>
          <v-flex pb-2 text-xs-center white--text xs12
            >&copy; {{ new Date().getFullYear() }} - Tokyo Camera Club
            Corp.</v-flex
          >
        </v-layout>
      </v-flex>
  </div>
</template>

<script>
import Toolbar from '@/components/molecules/Toolbar.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    Toolbar
  },
  computed: {
    ...mapGetters({ campaign: 'getCurrentCampaign' })
  }
};
</script>

<style lang="stylus" scoped>
.campaign-title
  margin: 10px;
</style>
